export default {
  // Tabs
  tabUsers: 'Usuarios',
  tabReferences: 'Referencias',
  tabEkrm: 'EKRM',
  tabRoles: 'Roles',
  tabGroups: 'Grupos',
  tabAuditTrail: 'Registro de Auditoría',

  // Users tab - toolbar
  saveChanges: 'Guardar Cambios',
  cancel: 'Cancelar',
  unsavedChanges: '{count} cambios sin guardar',
  search: 'Buscar',

  // Users tab - table headers
  headerEmail: 'Correo electrónico',
  headerModels: 'Modelos',
  headerActions: 'Acciones',

  // Users tab - models
  selectModels: 'Seleccionar Modelos',
  pending: 'Pendiente',

  // Users tab - delete dialog
  deleteUserTooltip: 'Eliminar Usuario',
  deleteDialogTitle: 'Advertencia',
  deleteDialogText: 'Eliminando usuario: {userName}',
  deleteDialogConfirmation: 'Esta acción no se puede deshacer. ¿Está seguro?',
  deleteButton: 'Eliminar',
  deleting: 'Eliminando...',

  // Alert messages
  alertClose: 'Cerrar',
  saveSuccessMessage: 'Cambios guardados exitosamente para {count} usuario(s)',
  saveErrorMessage: 'Error al guardar los cambios. Por favor, inténtelo de nuevo.',
  saveErrorWithDetails: 'Ocurrió un error al guardar los cambios: {error}',
  cancelledMessage: 'Cambios cancelados',
  deleteSuccessMessage: 'Usuario {userName} eliminado exitosamente',
  deleteErrorMessage: 'Error al eliminar usuario: {error}',
  loadErrorMessage: 'Error al cargar los datos. Por favor, actualice la página o contacte a soporte si el problema persiste.'
}
